import { render, staticRenderFns } from "./AdvancedDetailsForm.vue?vue&type=template&id=9804e4b0&scoped=true"
import script from "./AdvancedDetailsForm.vue?vue&type=script&lang=js"
export * from "./AdvancedDetailsForm.vue?vue&type=script&lang=js"
import style0 from "./AdvancedDetailsForm.vue?vue&type=style&index=0&id=9804e4b0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9804e4b0",
  null
  
)

export default component.exports